import { useState, useCallback, useRef } from 'react';
import { searchCarwashesByBounds } from '../api/carwash';
import { Carwash, MapBounds, MapFilters, SearchByBoundsMeta } from '../types/CarwashType';

interface CarwashSearchState {
  carwashes: Carwash[];
  meta: SearchByBoundsMeta | null;
  loading: boolean;
  error: string | null;
}

interface UseCarwashSearchReturn extends CarwashSearchState {
  search: (bounds: MapBounds, filters: MapFilters) => void;
}

const DEBOUNCE_MS = 400;

export function useCarwashSearch(): UseCarwashSearchReturn {
  const [state, setState] = useState<CarwashSearchState>({
    carwashes: [],
    meta: null,
    loading: false,
    error: null,
  });

  const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const search = useCallback((bounds: MapBounds, filters: MapFilters) => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(async () => {
      setState((prev) => ({ ...prev, loading: true, error: null }));

      try {
        const result = await searchCarwashesByBounds({
          ne_lat: bounds.ne_lat,
          ne_lng: bounds.ne_lng,
          sw_lat: bounds.sw_lat,
          sw_lng: bounds.sw_lng,
          search: filters.search || undefined,
          city: filters.city || undefined,
          state: filters.state || undefined,
          plan: filters.plan || undefined,
          service: filters.service || undefined,
          categoryId: filters.categoryId ? Number(filters.categoryId) : undefined,
          rating: filters.rating || undefined,
          order: filters.order,
          limit: 200,
        });

        setState({ carwashes: result.data, meta: result.meta, loading: false, error: null });
      } catch (err) {
        setState((prev) => ({
          ...prev,
          loading: false,
          error: 'Não foi possível carregar os parceiros',
        }));
      }
    }, DEBOUNCE_MS);
  }, []);

  return { ...state, search };
}
